// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"438":"online","552":"rules"}[chunkId] + "." + {"438":"b8fb6e33","552":"83001407"}[chunkId] + ".css";
};